export default __webpack_public_path__ + "static/media/tooltip-good-dog.c177e13a.svg";